import { Building2, KeyRound, type LucideIcon, Mail, Plug, SlidersHorizontal, Users } from 'lucide-react';

/**
 * The Super Admin console's sections.
 *
 * Each carries the permission that actually guards its endpoints, so the tab
 * strip and the route guard read from one list — a tab can never point at a
 * section the backend would 403. All four permissions are restricted-tier and
 * ungrantable to custom roles, which is what makes this a Super-Admin-only
 * surface by construction rather than by convention.
 */
export interface AdminTab {
  to: string;
  labelKey: string;
  icon: LucideIcon;
  permission: string;
}

export const ADMIN_TABS: AdminTab[] = [
  { to: '/admin/tenants', labelKey: 'admin.tabs.tenants' /* Organisations */, icon: Building2, permission: 'settings.platform' },
  { to: '/admin/users', labelKey: 'admin.tabs.users' /* Users */, icon: Users, permission: 'users.manage' },
  { to: '/admin/roles', labelKey: 'admin.tabs.roles' /* Roles */, icon: KeyRound, permission: 'roles.manage' },
  { to: '/admin/templates', labelKey: 'admin.tabs.templates' /* Templates */, icon: Mail, permission: 'settings.platform' },
  { to: '/admin/integrations', labelKey: 'admin.tabs.integrations' /* Integrations */, icon: Plug, permission: 'integrations.manage' },
  { to: '/admin/platform', labelKey: 'admin.tabs.platform' /* Platform */, icon: SlidersHorizontal, permission: 'settings.platform' },
];

/** The permissions that open the console at all (any-of) — derived, never a second list. */
export const ADMIN_PERMISSIONS: string[] = [...new Set(ADMIN_TABS.map((tab) => tab.permission))];
